export default __webpack_public_path__ + "static/media/icon1.c9e0cd4f.png";